export const formatString = (str: string) => {
  return str
    .replace(/([A-Z])/g, ' $1')
    .replace(/\b\w/g, (char: string) => char.toUpperCase())
    .trim();
};

export default formatString;
